import { ResolvedSegment } from './type';

type Translate = (key: string, options?: { defaultValue?: string }) => string;

/** Also serves the clients list, which carries a badge rather than a segment. */
export const segmentLabel = (segment: Pick<ResolvedSegment, 'label' | 'presetKey'>, t: Translate): string => {
  if (segment.label) {
    return segment.label;
  }
  if (segment.presetKey) {
    return t(`listCategory|presets.${segment.presetKey}.label`, { defaultValue: segment.presetKey });
  }
  return '';
};

export const segmentDescription = (segment: ResolvedSegment, t: Translate): string => {
  if (segment.description) {
    return segment.description;
  }
  if (segment.presetKey) {
    return t(`listCategory|presets.${segment.presetKey}.desc`, { defaultValue: '' });
  }
  return '';
};
